import { formatCellData } from './../pages/catalog/components/CatalogTable/utils/helper';
import { CellContext } from '@tanstack/react-table';
import { ColumnType } from '../pages/upload';

export const tableValueFormatter = ({ column: { id }, getValue }: CellContext<ColumnType, any>) =>
  ['site', 'Material', 'ProcessID'].includes(id) ? formatCellData(getValue()) : getValue();
